export function Refresh(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="20"
        height="23"
        viewBox="0 0 20 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.5847 0.313997C11.0559 -0.0650714 11.7469 -0.0359123 12.1843 0.401475L12.2718 0.49891C12.6509 0.970116 12.6217 1.66114 12.1843 2.09853L10.471 3.81185C15.3331 4.05702 19.2 8.07693 19.2 13C19.2 18.081 15.081 22.2 10 22.2C4.91898 22.2 0.800003 18.081 0.800003 13C0.800003 12.3373 1.33726 11.8 2 11.8C2.66274 11.8 3.2 12.3373 3.2 13C3.2 16.7555 6.24447 19.8 10 19.8C13.7555 19.8 16.8 16.7555 16.8 13C16.8 9.41296 14.0226 6.47462 10.501 6.21818L12.1843 7.90147L12.2718 7.99891C12.6509 8.47012 12.6217 9.16114 12.1843 9.59853C11.7157 10.0672 10.9559 10.0672 10.4873 9.59853L7.44437 6.55564L7.32748 6.42939C6.58716 5.56503 6.62613 4.26261 7.44437 3.44437L10.4873 0.401475L10.5847 0.313997Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
